// extracted by mini-css-extract-plugin
export default {"boundary":"ToutSlice_boundary__sfS4M","content":"ToutSlice_content__01Kj7","spacing":"ToutSlice_spacing__BYOgA"};